<section>
  <a routerLink="/find-real-estate" class="top-bar is-flex has-flex-align-center hide-on-tablet-up">
    <div class="back-image-wrapper is-flex has-flex-content-center has-flex-align-center">
      <img [src]="'/assets/icons/general_navigation/back_blue@1x.svg' | staticp" alt="Back">
    </div>
    <span style="margin-left: 10px" translate="navigation.back"></span>
  </a>

  <app-home-estimator [standalone]="true" (onContactAgent)="navigateToAgentSearch()"></app-home-estimator>
</section>
